import { Fragment } from "react";

import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { hideLoader, showLoader } from "../../../../store/actions";
import {
  getAccountType,
  saveAccountType,
} from "../../../../store/actions/newSubscriber";
import CardComponent from "../../transactions/newInvestor/lib/CardComponent";
import { useNewSubscriberContext } from "../Context/NewSubsciberContext";
import { setAccountTypes } from "../Context/NewSubscriberAction";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useRef } from "react";
import FormRadioGroup from "./lib/formik/RadioGroup";
import { SUCCESS_RESPONSE_CODE } from ".";

const InvestmentType = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    ackNumber,
    accountType: AT,
    dispatch: dispatchContext,
  } = useNewSubscriberContext();

  const { data = {} } = AT || {};
  const { AccountType = "1" } = data;

  const goBack = () => {
    history.push({
      pathname: "/nps/AddSubs/fatca-details",
    });
  };

  const initialValues = {
    accountType: AccountType,
  };

  const validationSchema = Yup.object().shape({
    accountType: Yup.string().required("Account Type is required"),
  });

  const _handleSubmit = async (values) => {
    try {
      dispatch(showLoader());
      const response = await dispatch(
        saveAccountType({
          AckNumber: ackNumber,
          AccountType: values.accountType,
        })
      );
      if (+response.statusCode === SUCCESS_RESPONSE_CODE) {
        const responseAcc = await dispatch(
          getAccountType({ AckNumber: ackNumber })
        );
        if (+responseAcc.statusCode === SUCCESS_RESPONSE_CODE) {
          dispatchContext(setAccountTypes(responseAcc));
        }
        history.push({
          pathname: "/nps/AddSubs/scheme-details",
        });
      }
    } catch (error) {
      alert(error);
      console.error(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const ref = useRef();

  return (
    <Fragment>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        innerRef={ref}
        onSubmit={_handleSubmit}
      >
        {({ values, setFieldValue, errors }) => (
          <Form>
            <CardComponent title="ACCOUNT TYPE">
              <div className="container-margin">
                <FormRadioGroup
                  label="Select Account Type"
                  name="accountType"
                  options={[
                    { label: "Tier I", value: "1" },
                    { label: "Tier I & II", value: "2" },
                  ]}
                  required
                />

                <div
                  style={{
                    marginLeft: "12px",
                    fontFamily: `'Roboto', sans-serif`,
                    fontSize: "14px",
                    fontWeight: 400,
                  }}
                >
                  Avail Tax Benefits under section 80C 80CCD{" "}
                </div>
                <div className="investment-type-card">
                  <div className="investment-type-box">
                    <h4 style={{ color: "#002856" }}>Tier I</h4>
                    <p>
                      - Tier I account is a non withdrawal permenant withdrawal
                      account.
                    </p>
                    <p>
                      - Allow to withdraw up to 50 % if her/his contribution
                      after completing 25 year of her/his service.
                    </p>
                  </div>
                  <div className="investment-type-box">
                    <h4 style={{ color: "#002856" }}>Tier I & II</h4>

                    <p>
                      - NPS Tier II account allows you to have unlimited
                      withdrawals.
                    </p>
                    <p>
                      - NPS Tier II account allows you to have unlimited
                      withdrawals.It works just like a saving account
                    </p>
                  </div>
                </div>
              </div>
            </CardComponent>
            <>
              <div className="d-flex justify-content-center">
                <button
                  className="new-investor-button"
                  onClick={goBack}
                  disabled={!goBack}
                  style={{ border: "1px solid #007ac8", color: "#007ac8" }}
                >
                  Back
                </button>
                <button
                  type="submit"
                  className="new-investor-button new-investor-active"
                >
                  Proceed
                </button>
              </div>
            </>
          </Form>
        )}
      </Formik>
    </Fragment>
  );
};

export default InvestmentType;
